<template>
  <section v-if="blok" v-editable="blok" testimonials :data-spacing="blok?.spacing || 'open'">
    <div class="container">
      <div class="row section-header">
        <h2 v-if="blok?.title" class="section-title">
          <StoryblokRichText :resolvers="richtextResolvers" :doc="blok.title" />
        </h2>
      </div>
      <div v-if="blok?.slides && blok?.slides?.length > 0" class="row">
        <swiper-container id="testimonials-swiper" ref="containerRef" :init="false">
          <swiper-slide v-for="slide in blok.slides" :key="slide._uid" :style="{ '--quote-color': slide?.color ? slide.color.value : null }">
            <SnippetQuote class="slider-quote slider-quote-open" />
            <StoryblokComponent :blok="slide" />
            <SnippetQuote class="slider-quote slider-quote-close" />
          </swiper-slide>

          <div slot="container-end" class="slider-footer">
            <div title="Slider Arrow" class="slider-arrows">
              <a href="#prev" title="Previous Slide" aria-label="Previous Slide" role="button" class="slider-arrow slider-prev">
                <span class="sr-only">Previous Slide</span>
              </a>
              <a href="#next" title="Next Slide" aria-label="Next Slide" role="button" class="slider-arrow slider-next">
                <span class="sr-only">Next Slide</span>
              </a>
            </div>
          </div>
        </swiper-container>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
  import { Navigation, A11y } from "swiper/modules";
  import { richtextResolvers } from "#imports";
  import "swiper/element/css/navigation";

  defineProps({ blok: Object });

  const a11y = {
    id: "testimonials-swiper",
  };

  const navigation = {
    nextEl: "[testimonials] .slider-next",
    prevEl: "[testimonials] .slider-prev",
  };

  const containerRef = ref(null);
  const swiper = useSwiper(containerRef, {
    modules: [Navigation, A11y],
    slidesPerView: 1,
    spaceBetween: 32,
    loop: false,
    rewind: true,
    navigation,
    a11y,
  });

  onMounted(() => {
    swiper.instance;
  });
</script>
<style src="~/assets/scss/section/testimonials.scss" lang="scss"></style>
